import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

import { TabsBaseStyleParts } from './tabs.types';

export const tabsBaseStyleParts: TabsBaseStyleParts = {
  root: {
    width: '100%',
  },
  wrapper: {
    width: '100%',
    margin: '0 auto',
  },
  tab: {
    padding: 0,
    minWidth: 0,
    overflow: 'visible',
  },
  divider: {
    borderBottom: 2,
    borderColor: 'divider',
    margin: { sm: '56px 56px 0 56px', xs: '48px 16px 0 16px' },
  },
  tabsList: {
    '& .MuiTabs-list': {
      gap: '40px',
    },
    '& .MuiTabs-indicator': {
      height: '3px',
      backgroundColor: 'black',
    },
    '& .Mui-selected': {
      color: `${paletteBase.black} !important`,
    },
  },
};

export const centerAlignmentStyles: AbgSxProps = {
  '& .MuiTabs-flexContainer': {
    justifyContent: { sm: 'center' },
  },
};
